<form [formGroup]="form" (ngSubmit)="onSubmit()" class="st-form">
  <app-input
    label="Sigle"
    type="text"
    formControlName="sigle"
    placeholder="Ex: SAMB"
  ></app-input>
  <app-input
    label="Nom complet"
    type="text"
    formControlName="nomComplet"
    placeholder="Ex: Organisation Non Gouvernementale"
  ></app-input>
  <div class="logo-upload">
    <label class="logo-upload__label">Logo</label>

    <div class="logo-upload__dropzone" (click)="fileInput.click()">
      @if (getLogoUrl()) {
        <img [src]="getLogoUrl()" alt="Logo" class="logo-upload__preview" />
      } @else {
        <span class="logo-upload__placeholder">Aucun logo</span>
      }
      @if (uploadingLogo) {
        <div class="logo-upload__overlay">
          <span class="logo-upload__spinner"></span>
        </div>
      }
      @if (uploadFailed) {
        <div class="logo-upload__overlay logo-upload__overlay--danger">
          <svg class="logo-upload__danger-icon" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      }
    </div>

    <input
      #fileInput
      type="file"
      accept="image/*"
      class="logo-upload__input"
      (change)="onLogoFileSelected($event)"
    />

    <button
      type="button"
      class="logo-upload__btn"
      (click)="fileInput.click()"
      [disabled]="uploadingLogo"
    >
      {{
        uploadingLogo
          ? "Envoi..."
          : getLogoUrl()
            ? "Changer le logo"
            : "Choisir un logo"
      }}
    </button>

    @if (uploadError) {
      <div class="logo-upload__error">
        <svg class="logo-upload__error-icon" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>{{ uploadError }}</span>
      </div>
    }

    
  </div>
  <app-ui-button
    label="Enregistrer"
    type="submit"
    variant="primary"
    [loading]="saving"
    [disabled]="form.invalid"
  ></app-ui-button>
</form>
